"use client";
import clsx from "clsx";
import { PropsWithChildren, useEffect, useRef } from "react";
import styles from "./Collapsible.module.scss";

type Props = {
	isOpen: boolean;
	className?: string;
};

export default function Collapsible({
	isOpen,
	className,
	children,
}: PropsWithChildren<Props>) {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (!ref.current) return;

		if (isOpen) {
			ref.current.style.maxHeight = `${ref.current.scrollHeight}px`;
		} else {
			ref.current.style.maxHeight = "0";
		}
	}, [isOpen]);
	return (
		<div ref={ref} className={clsx(styles.collapsible, className)}>
			{children}
		</div>
	);
}
